import React from 'react';
import Item from './Item.js';

const ItemList = (props) => {
  const { host, itemData, openModal } = props;

  return (
    <div className='items-container'>
      {itemData &&
        itemData.map((items, idx) => {
          return items.map((item, index) => {
            return (
              <Item
                host={host}
                item={item}
                key={index}
                id={idx > 0 ? index * idx : index}
                openModal={openModal}
              />
            );
          });
        })}
    </div>
  );
};

export default ItemList;
